<template>
<div class="pagination">
  
    <button class="pagination-btn first" :disabled="currentPage === 1" @click="$emit('page-change', 1)">First</button>
    <button
      v-for="page in pages"
      :key="page"
      class="pagination-btn"
      :class="{ active: page === currentPage }"
      @click="$emit('page-change', page)"
    >
      {{ page }}
    </button>
    <button class="pagination-btn last" :disabled="currentPage === totalPages" @click="$emit('page-change', totalPages)">Last</button>
  </div>
</template>

<script>
export default {
  name: 'AppPagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pages() {
      // Show up to 5 pages, centered around currentPage
      const pages = [];
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.totalPages, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
  },
};
</script>


